import * as LegacyCalReportConstants from './LegacyCalReportConstants';
import { produce } from 'immer';
import { STATUS_PENDING, STATUS_SUCCESS, STATUS_FAILURE, STATUS_RESET } from 'Common/constants/commonConstants';

const initialState = {};

export default function LegacyCalReportReducer(state = initialState, action) {
    switch (action.type) {
        case LegacyCalReportConstants.LEGACY_CAL_REPORT_FETCHING: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    reportStatus: STATUS_PENDING,
                    error: null
                    // Don't clear reportData - keep previous data while loading
                };
            });
            return newState;
        }

        case LegacyCalReportConstants.LEGACY_CAL_REPORT_FETCHED: {
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    reportStatus: STATUS_SUCCESS,
                    error: null,
                    reportData: action.payload.data.result
                };
            });
            return newState;
        }

        case LegacyCalReportConstants.LEGACY_CAL_REPORT_FAILED: {
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    reportStatus: STATUS_FAILURE,
                    error: action.payload.error,
                    reportData: null
                };
            });
            return newState;
        }

        case LegacyCalReportConstants.LEGACY_CAL_REPORT_RESET: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    draft[action.payload].reportStatus = STATUS_RESET;
                }
            });
            return newState;
        }

        default:
            return state;
    }
}
